<template>
  <div class="sucess-code-container">
    <img
      class="mask-complete"
      src="@/assets/images/playhera-indo/mask_complete.svg"
      alt=""
    />
    <img
      class="icon-complete"
      src="@/assets/images/playhera-indo/completed_icon.svg"
      alt=""
    />
    <div class="wrapper-content-sucess-code">
      <div class="wraper-title">
        <h1 class="header">
          Congratulations!
        </h1>
        <h3 class="text-modal">
          You're successfully signed up.
        </h3>
      </div>

      <button class="done-btn" @click="closeModal">
        Done
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

// import HeraLogo from '@/components/atoms/HeraLogo';
// import BackBtn from '@/components/common/GoBackBtn';

let routerNameTo;

export default {
  name: 'AccountCreatedModal',

  data() {
    return {};
  },
  computed: {},

  created() {
    this.$options.verifyCodeCount = 4;
  },
  destroyed() {
    if (
      routerNameTo &&
      routerNameTo !== 'signup' &&
      routerNameTo !== 'passwordReset'
    ) {
      this.saveRegData(null);
    }
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    formSubmit() {
      this.closeModal;
    },
  },
};
</script>
<style lang="scss" scoped>
.sucess-code-container {
  display: flex;
  width: 100%;
  padding: 40px 32px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  background: #151520 !important;
  overflow: hidden;
  max-width: 625px;
  min-width: 625px;
  @media (max-width: 915px) {
    max-width: 525px;
    min-width: 525px;
  }
  @media (max-width: 600px) {
    max-width: 455px;
    min-width: 455px;
  }
  @media (max-width: 450px) {
    max-width: 325px;
    min-width: 325px;
  }

  > .mask-complete {
    position: relative;
    overflow: hidden;
    top: 0;
  }
  > .icon-complete {
    position: absolute;
    overflow: hidden;
    top: 85px;
  }
  > .wrapper-content-sucess-code {
    display: flex;
    width: 100%;
    padding: 40px 32px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    > .wraper-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 4px;
      align-self: stretch;

      > .header {
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 135%; /* 43.2px */
        letter-spacing: -0.48px;
        background: var(
          --Title,
          linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.5) 5.29%,
            rgba(255, 255, 255, 0.91) 51.55%,
            rgba(255, 255, 255, 0.5) 100%
          )
        );
        background-clip: content-box;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      > .text-modal {
        font-size: 14px;
        font-style: normal;
        max-width: 465px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.5);
        text-align: center;
      }
    }
    > .done-btn {
      width: 100%;
      display: flex;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      align-self: stretch;
      border-radius: 16px;
      background: #fff;
    }
  }
}

.sucess-code-loader {
  width: 100vw !important;
}
</style>
